/**
 * Shared event helpers for knowledge-placement UI refresh.
 * Source of truth is now server-side (cross-device) via LevelProgression APIs.
 */

export const KNOWLEDGE_PLACEMENT_EVENT = 'app:knowledge-placement-updated';

export type KnowledgePlacementOutcome = 'recommended' | 'advanced' | 'opt_out';

export interface KnowledgePlacementRecommendation {
  courseId: number;
  courseTitle: string;
  levelId: number;
  lessonId: number;
  quizTitle: string;
  contextSubtitle: string;
  evaluatedAt: string;
}

export function emitKnowledgePlacementUpdated(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(KNOWLEDGE_PLACEMENT_EVENT));
}
